import gql from 'graphql-tag';
import moment from 'moment';
import { getAxios, getGraphql } from './apiUtils';
import { DAILY_DIGEST_FIELDS, HOME_OF_THE_WEEK_FIELDS } from './fragments';
import * as R from 'ramda';
import { PROMO_ALERT_FIELDS } from './fragments/PromoAlert.fragment';
import { NEWS_ALERT_FIELDS } from './fragments/NewsAlert.fragment';

// POSTS
export const getTopPosts = async params => {
  try {
    return await getAxios()
      .get(`/api/rebel-mouse/top`, { params })
      .then(({ data }) => data);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const recentPosts = async ({ siteId }) => {
  try {
    const result = await getAxios().get(`/api/rebel-mouse/recent?siteId=${siteId}`);
    return result.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getPostById = async ({ id, siteId }) => {
  try {
    const result = await getAxios().get(`/api/rebel-mouse/detail?siteId=${siteId}&id=${id}`);
    return result.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getPostHistoryById = async ({ id, siteId }) => {
  try {
    const result = await getAxios().get(`/api/rebel-mouse/history?siteId=${siteId}&id=${id}`);
    return result.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const searchDigests = async ({ siteId, subject, style, sendDate, pageSize, offset }) => {
  console.log('search digests');
  try {
    const and = [{ siteId: { isNot: null } }, { sendDate: { isNot: null } }];

    const isValid = val => val && val !== 'All';

    if (isValid(subject) && subject) {
      and.push({ subject: { iLike: `%${subject}%` } });
    }

    if (isValid(style) && style) {
      and.push({ style: { iLike: `%${style}%` } });
    }

    if (isValid(sendDate) && sendDate) {
      and.push({ sendDate: { iLike: `%${sendDate}%` } });
    }

    if (siteId && isValid(siteId)) {
      and.push({ siteId: { in: [siteId] } });
    }

    const query = gql`
      ${DAILY_DIGEST_FIELDS}
      query SEARCH_DAILY_DIGESTS($filter: emailDailyDigestFilter, $pageSize: Int, $offset: Int) {
        emailDailyDigests(
          filter: $filter
          paging: { limit: $pageSize, offset: $offset }
          sorting: [{ field: sendDate, direction: DESC }]
        ) {
          totalCount
          nodes {
            ...DailyDigestFields
          }
        }
      }
    `;

    const getFormattedDate = item => {
      if (!item || !item.sendDate || !item.sendTime) return '';
      const date = date => moment(date).format('MMM D, YYYY');
      const time = time => (moment(time, 'hh:mm:ss').isValid() ? moment(time, 'hh:mm:ss').format('h:mm a') : '');
      return [date(item.sendDate), time(item.sendTime)].filter(a => a).join(', ');
    };

    return getGraphql()
      .query({ query, variables: { filter: { and }, pageSize, offset } })
      .then(results => {
        const digests = R.path(['data', 'emailDailyDigests', 'nodes'])(results);
        const count = R.path(['data', 'emailDailyDigests', 'totalCount'])(results);
        return {
          digests: digests.map(digest => ({
            ...digest,
            sendDateFormatted: getFormattedDate(digest),
          })),
          count,
        };
      });
  } catch (error) {
    throw new Error(error.message);
  }
};

export const searchPosts = searchDigests;

// export const searchPosts = async ({ siteId, subject, style, sendDate }) => {
//   try {
//     const and = [];

//     const isValid = val => val && val !== 'All';

//     if (isValid(subject)) {
//       and.push({ subject: { iLike: `%${subject}%` } });
//     }

//     if (isValid(style)) {
//       and.push({ style: { iLike: `%${style}%` } });
//     }

//     if (isValid(sendDate)) {
//       and.push({ sendDate: { iLike: `%${sendDate}%` } });
//     }

//     if (isValid(siteId)) {
//       and.push({ siteId: { in: [siteId] } });
//     }

//     const query = gql`
//       ${DAILY_DIGEST_FIELDS}
//       query SEARCH_DAILY_DIGESTS($filter: emailDailyDigestFilter!) {
//         emailDailyDigests(filter: $filter, paging: { limit: $pageSize, offset: $offset }) {
//           nodes {
//             ...DailyDigestFields
//           }
//         }
//       }
//     `;

//     const getFormattedDate = item => {
//       console.table({ date: item.sendDate, time: item.sendTime });
//       if (!item || !item.sendDate || !item.sendTime) return '';
//       const date = date => moment(date).format('MMM D, YYYY');
//       const time = time => (moment(time, 'hh:mm:ss').isValid() ? moment(time, 'hh:mm:ss').format('h:mm a') : '');
//       return [date(item.sendDate), time(item.sendTime)].filter(a => a).join(', ');
//     };

//     return getGraphql()
//       .query({ query, variables: { filter: { and } } })
//       .then(results => {
//         const digests = R.path(['data', 'emailDailyDigests', 'nodes'])(results);
//         const count = R.path(['data', 'emailDailyDigests', 'totalCount'])(results);
//         return {
//           digests: digests.map(digest => ({
//             ...digest,
//             sendDateFormatted: getFormattedDate(digest),
//           })),
//           count,
//         };
//       });
//   } catch (error) {
//     throw new Error(error.message);
//   }
// };

export const searchHOTW = async ({ siteId, subject, style, status, sendDate, pageSize, offset, column, direction }) => {
  try {
    const and = [];

    const isValid = val => val && val !== 'All';

    if (isValid(subject)) {
      and.push({ subject: { iLike: `%${subject}%` } });
    }

    if (isValid(style)) {
      and.push({ style: { iLike: `%${style}%` } });
    }

    if (isValid(sendDate)) {
      and.push({ sendDate: { iLike: `%${sendDate}%` } });
    }

    if (isValid(siteId)) {
      and.push({ siteId: { in: [siteId] } });
    }

    if (isValid(status)) {
      and.push({ isScheduled: { is: status === 'Scheduled' } });
    }

    and.push({ siteId: { isNot: null } });

    const query = gql`
      ${HOME_OF_THE_WEEK_FIELDS}
      query SEARCH_HOTW(
        $filter: emailHomeOfTheWeekFilter
        $pageSize: Int
        $offset: Int
        $column: emailHomeOfTheWeekSortFields!
        $direction: SortDirection!
        $column2: emailHomeOfTheWeekSortFields!
        $direction2: SortDirection!
      ) {
        emailHomeOfTheWeeks(
          filter: $filter
          paging: { limit: $pageSize, offset: $offset }
          sorting: [{ field: $column2, direction: $direction2 }, { field: $column, direction: $direction }]
        ) {
          totalCount
          nodes {
            ...HomeOfTheWeekFields
          }
        }
      }
    `;

    return getGraphql()
      .query({
        query,
        variables: { filter: { and }, pageSize, offset, column, direction, column2: 'isScheduled', direction2: 'ASC' },
      })
      .then(results => {
        const digests = R.path(['data', 'emailHomeOfTheWeeks', 'nodes'])(results);
        const count = R.path(['data', 'emailHomeOfTheWeeks', 'totalCount'])(results);
        return { digests, count };
      })
      .then(({ digests, count }) => {
        const date = date => moment(date).format('MMM D, YYYY');
        const time = time => (moment(time, 'hh:mm').isValid() ? moment(time, 'hh:mm').format('h:mm a') : '');

        const data = digests.map(digest => ({
          ...digest,
          sendDateFormatted: [date(digest.sendDate), time(digest.sendTime)].filter(a => a).join(', '),
        }));

        return { digests: data, count };
      });
  } catch (error) {
    throw new Error(error.message);
  }
};
export const searchPromoAlerts = async ({
  siteId,
  subject,
  style,
  excludeStyle,
  status,
  sendDate,
  pageSize = 50,
  offset = 0,
  column,
  direction,
}) => {
  try {
    console.log({ status });
    const and = [];

    const isValid = val => {
      const normalized = typeof val === 'string' ? val.trim() : val;
      return normalized && normalized !== 'All';
    };

    if (isValid(subject)) {
      and.push({ subject: { iLike: `%${subject}%` } });
    }

    if (isValid(style)) {
      and.push({ style: { iLike: `%${style}%` } });
    }

    if (isValid(excludeStyle)) {
      and.push({ style: { notILike: excludeStyle } });
    }

    if (isValid(sendDate)) {
      and.push({ sendDate: { iLike: `%${sendDate}%` } });
    }

    if (isValid(siteId)) {
      and.push({ siteId: { in: [siteId] } });
    }

    if (isValid(status)) {
      and.push({ isScheduled: { is: status === 'Scheduled' } });
    }

    and.push({ siteId: { isNot: null } });

    const query = gql`
      ${PROMO_ALERT_FIELDS}
      query SEARCH_HOTW(
        $filter: emailPromoAlertFilter
        $pageSize: Int
        $offset: Int
        $column: emailPromoAlertSortFields!
        $direction: SortDirection!
        $column2: emailPromoAlertSortFields!
        $direction2: SortDirection!
      ) {
        emailPromoAlerts(
          filter: $filter
          paging: { limit: $pageSize, offset: $offset }
          sorting: [{ field: $column2, direction: $direction2 }, { field: $column, direction: $direction }]
        ) {
          totalCount
          nodes {
            ...PromoAlertFields
          }
        }
      }
    `;

    return getGraphql()
      .query({
        query,
        variables: {
          filter: { and },
          pageSize: pageSize || 50,
          offset: offset || 0,
          column,
          direction,
          column2: 'isScheduled',
          direction2: 'ASC',
        },
      })
      .then(results => {
        const digests = R.path(['data', 'emailPromoAlerts', 'nodes'])(results);
        const count = R.path(['data', 'emailPromoAlerts', 'totalCount'])(results);
        return { digests, count };
      })
      .then(({ digests, count }) => {
        const date = date => moment(date).format('MMM D, YYYY');
        const time = time => (moment(time, 'hh:mm').isValid() ? moment(time, 'hh:mm').format('h:mm a') : '');
        return {
          digests: digests.map(digest => ({
            ...digest,
            sendDateFormatted: [date(digest.sendDate), time(digest.sendTime)].filter(a => a).join(', '),
          })),
          count,
        };
      });
  } catch (error) {
    throw new Error(error.message);
  }
};

// CAMPAIGN
export const getDigests = async () => {
  const query = gql`
    ${DAILY_DIGEST_FIELDS}
    query GET_DIGEST_EMAILS {
      emailDailyDigests(
        sorting: [{ field: dateCreated, direction: DESC }]
        filter: { and: [{ city: { isNot: null } }, { city: { notILike: "" } }] }
      ) {
        nodes {
          ...DailyDigestFields
        }
      }
    }
  `;

  return getGraphql()
    .query({ query })
    .then(R.path(['data', 'emailDailyDigests', 'nodes']))
    .then(digests => {
      const date = date => moment(date).format('MMM D, YYYY');
      const time = time => (moment(time, 'hh:mm').isValid() ? moment(time, 'hh:mm').format('h:mm a') : '');

      return digests.map(digest => ({
        ...digest,
        sendDateFormatted: [date(digest.sendDate), time(digest.sendTime)].filter(a => a).join(', '),
      }));
    });
};
export const getMailchimpAudiences = async siteId => {
  return getAxios()
    .get(`/api/mailchimp/audiences?siteId=${siteId}`)
    .then(R.path(['data', 'lists']))
    .then(lists =>
      lists.map(list => ({
        id: list.id,
        name: list.name,
      }))
    );
};

export const getDigestById = async id => {
  try {
    const { data } = await getAxios().get(`/api/daily-digest/${id}`);
    data.sendDate = data.sendDate ? moment.utc(data.sendDate).format('YYYY-MM-DD') : '';
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const deleteHotwById = async id => {
  try {
    const DELETE_HOTW_EMAIL = gql`
      mutation DELETE_HOTW_EMAIL($id: ID!) {
        deleteOneEmailHomeOfTheWeek(input: { id: $id }) {
          id
        }
      }
    `;

    return getGraphql().mutate({ mutation: DELETE_HOTW_EMAIL, variables: { id } });
  } catch (error) {
    throw new Error(error.message);
  }
};

export const deletePromoAlertById = async id => {
  try {
    const DELETE_PROMO_ALERT = gql`
      mutation DELETE_PROMO_ALERT($id: ID!) {
        deleteOneEmailPromoAlert(input: { id: $id }) {
          id
        }
      }
    `;

    return getGraphql().mutate({ mutation: DELETE_PROMO_ALERT, variables: { id } });
  } catch (error) {
    throw new Error(error.message);
  }
};
export const deleteDigestById = async id => {
  try {
    const DELETE_DIGEST_EMAIL = gql`
      mutation DELETE_DIGEST_EMAIL($id: ID!) {
        deleteOneEmailDailyDigest(input: { id: $id }) {
          id
        }
      }
    `;

    return getGraphql().mutate({ mutation: DELETE_DIGEST_EMAIL, variables: { id } });
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getDigestTestEmail = async id => {
  try {
    const response = await getAxios().get(`/api/daily-digest/test-email/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getHotwListingById = async id => {
  try {
    const response = await getAxios().get(`/api/hotw/listing/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getHotwTestEmail = async id => {
  try {
    const response = await getAxios().get(`/api/hotw/test-email/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const addDigest = async digest => {
  try {
    return await getAxios()
      .post(`/api/daily-digest`, digest)
      .then(({ data }) => data);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getMailchimpStatus = async digestId => {
  try {
    return await getAxios()
      .get(`/api/daily-digest/status/` + digestId)
      .then(({ data }) => data);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const unschedule = async digestId => {
  try {
    return await getAxios()
      .put(`/api/daily-digest/unschedule/` + digestId)
      .then(({ data }) => data)
      .catch(e => console.log('e'));
  } catch (error) {
    console.log('error');
  }
};

export const updateDigest = async digest => {
  try {
    return await getAxios().put(`/api/daily-digest`, digest);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const scheduleDigest = async digest => {
  try {
    return await getAxios().put(`/api/daily-digest/schedule`, digest);
  } catch (error) {
    throw new Error(error.message);
  }
};

// HOTW
export const getHOTW = async () => {
  try {
    const GET_HOTW_EMAILS = gql`
      ${HOME_OF_THE_WEEK_FIELDS}
      query GET_HOTW_EMAILS {
        emailHomeOfTheWeeks(filter: { and: [{ siteId: { isNot: null } }] }) {
          nodes {
            ...HomeOfTheWeekFields
          }
        }
      }
    `;

    return getGraphql()
      .query({ query: GET_HOTW_EMAILS })
      .then(R.path(['data', 'emailHomeOfTheWeeks', 'nodes']));
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getHotwById = async id => {
  try {
    const { data } = await getAxios().get(`/api/hotw/${id}`);
    data.sendDate = data.sendDate ? moment(data.sendDate, 'YYYY-MM-DD').format('YYYY-MM-DD') : '';
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const addHOTW = async publication => {
  try {
    return await getAxios()
      .post(`/api/hotw`, publication)
      .then(({ data }) => data);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const updateHOTW = async publication => {
  try {
    return await getAxios()
      .put(`/api/hotw`, publication)
      .then(res => res?.data);
  } catch (error) {
    throw new Error(error.message);
  }
};

// export const addHOTW = async publication => {
//   try {
//     const mutation = gql`
//       ${HOME_OF_THE_WEEK_FIELDS}
//       mutation CREATE_HOTW_EMAIL($emailHomeOfTheWeek: CreateEmailHomeOfTheWeek!) {
//         createOneEmailHomeOfTheWeek(input: { emailHomeOfTheWeek: $emailHomeOfTheWeek }) {
//           ...HomeOfTheWeekFields
//         }
//       }
//     `;

//     return getGraphql()
//       .mutate({ mutation, variables: { emailHomeOfTheWeek: publication } })
//       .then(R.path(['data', 'createOneEmailHomeOfTheWeek']));
//   } catch (error) {
//     throw new Error(error.message);
//   }
// };

// export const updateHOTW = async publication => {
//   try {
//     const mutation = gql`
//       ${HOME_OF_THE_WEEK_FIELDS}
//       mutation UPDATE_HOTW_EMAIL($id: ID!, $email: UpdateEmailHomeOfTheWeek!) {
//         updateOneEmailHomeOfTheWeek(input: { id: $id, update: $email }) {
//           ...HomeOfTheWeekFields
//         }
//       }
//     `;

//     const { id, ...email } = publication;

//     return getGraphql()
//       .mutate({ mutation, variables: { id, email } })
//       .then(R.path(['data', 'updateOneEmailHomeOfTheWeek']));
//   } catch (error) {
//     throw new Error(error.message);
//   }
// };

export const scheduleHOTW = async publication => {
  try {
    return await getAxios().put(`/api/hotw/schedule`, publication);
  } catch (error) {
    throw new Error(error.message);
  }
};

// Promo Alerts
export const getPromoAlerts = async () => {
  try {
    const GET_PROMO_ALERTS = gql`
      ${PROMO_ALERT_FIELDS}
      query GET_PROMO_ALERTS {
        emailPromoAlerts(
          sorting: [{ field: sendDate, direction: DESC }]
          filter: { and: [{ siteId: { isNot: null } }] }
          paging: { limit: 50 }
        ) {
          nodes {
            ...PromoAlertFields
          }
        }
      }
    `;

    return getGraphql()
      .query({ query: GET_PROMO_ALERTS })
      .then(R.path(['data', 'emailPromoAlerts', 'nodes']));
    // .then(R.map(R.prop('node')));
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getPromoAlertById = async id => {
  try {
    const { data } = await getAxios().get(`/api/promo-alert/${id}`);
    data.sendDate = data.sendDate ? moment(data.sendDate, 'YYYY-MM-DD').format('YYYY-MM-DD') : '';
    data.endDate = data.endDate ? moment(data.endDate, 'YYYY-MM-DD').format('YYYY-MM-DD') : '';
    data.startDate = data.startDate ? moment(data.startDate).format('YYYY-MM-DD @ h:mm a') : '';
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const addPromoAlert = async publication => {
  try {
    return await getAxios()
      .post(`/api/promo-alert`, publication)
      .then(({ data }) => data);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const updatePromoAlert = async publication => {
  try {
    return await getAxios()
      .put(`/api/promo-alert`, publication)
      .then(res => res?.data);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const schedulePromoAlert = async publication => {
  try {
    return await getAxios().put(`/api/promo-alert/schedule`, publication);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getPromoAlertTestEmail = async id => {
  try {
    return await getAxios()
      .get(`/api/promo-alert/test-email/${id}`)
      .then(({ data }) => data);
  } catch (error) {
    throw new Error(error.message);
  }
};

// NEWS ALERTS
export const getNewsAlerts = async () => {
  try {
    const query = gql`
      ${NEWS_ALERT_FIELDS}
      query GET_NEWS_ALERTS {
        newsAlerts(sorting: [{ field: sendDate, direction: DESC }], filter: { and: [{ siteId: { isNot: null } }] }) {
          nodes {
            ...NewsAlertFields
          }
        }
      }
    `;

    return getGraphql()
      .query({ query })
      .then(R.path(['data', 'newsAlerts', 'nodes']))
      .then(alerts => {
        return alerts.map(alert => ({
          ...alert,
          sendDate: moment(alert.sendDate),
        }));
      });
    // .then(R.map(R.prop('node')));
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getNewsAlertById = async id => {
  try {
    const query = gql`
      ${NEWS_ALERT_FIELDS}
      query GET_NEWS_ALERT($id: ID!) {
        newsAlert(id: $id) {
          ...NewsAlertFields
        }
      }
    `;
    return getGraphql()
      .query({ query, variables: { id } })
      .then(R.path(['data', 'newsAlert']));
  } catch (error) {
    throw new Error(error.message);
  }
};

export const addNewsAlert = async newsAlert => {
  const mutation = gql`
    mutation CREATE_NEWS_ALERT($newsAlert: CreateNewsAlert!) {
      createOneNewsAlert(input: { newsAlert: $newsAlert }) {
        id
      }
    }
  `;

  return getGraphql()
    .mutate({ mutation, variables: { newsAlert } })
    .then(R.path(['data', 'createOneNewsAlert']));
};

export const updateNewsAlert = async newsAlert => {
  const { id, __typename, site, emailTemplate, ...update } = newsAlert;
  const mutation = gql`
    mutation UPDATE_NEWS_ALERT($id: ID!, $update: UpdateNewsAlert!) {
      updateOneNewsAlert(input: { id: $id, update: $update }) {
        id
      }
    }
  `;

  return getGraphql().mutate({ mutation, variables: { id, update } });
};

export const deleteNewsAlert = async id => {
  const mutation = gql`
    mutation DELETE_NEWS_ALERT($id: ID!) {
      deleteOneNewsAlert(input: { id: $id }) {
        id
      }
    }
  `;

  return getGraphql().mutate({ mutation, variables: { id } });
};

export const scheduleNewsAlert = async publication => {
  try {
    return await getAxios().put(`/api/news-alert/schedule`, publication);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const sendNewsAlertTestEmail = async id => {
  try {
    return await getAxios().post(`/api/news-alert/test-email/${id}`);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getNewsAlertTestEmail = async id => {
  try {
    return await getAxios()
      .get(`/api/news-alert/test-email/${id}`)
      .then(({ data }) => data);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const searchNewsAlerts = async ({ siteId, subject }) => {
  try {
    const and = [];

    const isValid = val => val && val !== 'All';

    if (isValid(subject)) {
      and.push({ subject: { iLike: `%${subject}%` } });
    }

    if (isValid(siteId)) {
      and.push({ siteId: { in: [siteId] } });
    }

    const query = gql`
      ${NEWS_ALERT_FIELDS}
      query SEARCH_NEWS_ALERTS($filter: newsAlertFilter!) {
        newsAlerts(filter: $filter) {
          nodes {
            ...NewsAlertFields
          }
        }
      }
    `;

    return getGraphql()
      .query({ query, variables: { filter: { and } } })
      .then(R.path(['data', 'newsAlerts', 'nodes']));
  } catch (error) {
    throw new Error(error.message);
  }
};
